<ng-container *ngIf="(selectedCategory$ | async)?.children.length > 1">
  <app-sub-category-grid
    [categories]="(selectedCategory$ | async)?.children"
    [parentCategoryName]="(selectedCategory$ | async)?.name"
    [isMobile]="isMobile"
    [isTablet]="isTablet"
    [isDesktop]="isDesktop"
  ></app-sub-category-grid>
</ng-container>
